import { stats } from "@/mocks/site";

const values = [
  {
    icon: "ri-shield-check-line",
    color: "bg-secondary-100 text-secondary-900",
    title: "编辑人工把关",
    desc: "每篇好料都经栏目编辑人工筛选与核实，不靠搬运凑量，也不靠标题博眼球。",
  },
  {
    icon: "ri-focus-3-line",
    color: "bg-primary-100 text-primary-800",
    title: "只选值得看",
    desc: "判断标准始终如一：观点是否清晰、信息是否可靠、读完是否有收获。",
  },
  {
    icon: "ri-timer-flash-line",
    color: "bg-accent-100 text-accent-900",
    title: "每日滚动更新",
    desc: "热门推荐随当日动态刷新，精选榜单定期复盘重排，打开就是新鲜的。",
  },
  {
    icon: "ri-scales-3-line",
    color: "bg-secondary-100 text-secondary-900",
    title: "不浪费你时间",
    desc: "排版克制、重点清晰、节奏舒服，让你用最短时间读到最有价值的内容。",
  },
];

export default function ValuesSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-md bg-primary-100 px-2.5 py-1 text-xs font-semibold text-primary-800">
            <i className="ri-question-line" />
            为什么相信看料
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            为「值得看」定一个标准
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
            信息越泛滥，「甄选」越稀缺。看料把编辑判断放在第一位，
            用一套稳定原则，替你做最费时间的筛选工作。
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-xl border border-background-200/80 bg-background-100 p-6 transition-colors hover:border-primary-200"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-lg text-2xl ${v.color}`}>
                <i className={v.icon} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{v.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </div>

        {/* 数据条 */}
        <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl bg-background-200/80 lg:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center justify-center bg-background-100 py-8 text-center">
              <span className="font-heading text-3xl font-black text-primary-600 md:text-4xl">{s.value}</span>
              <span className="mt-2 text-sm text-foreground-600">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}